// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"wa_a bhk_b bhk_wb"};